/** @format */

const Number = ({ field, onChangeValue, teamForm }) => {
	return (
		<div className='form-group d-flex flex-column'>
			<label>{field.label}</label>
			<input
				type='number'
				className='form-control f-13'
				defaultValue={field?.value ?? ''}
				onChange={(e) => onChangeValue(field.name, e.target.value, teamForm)}
			/>
		</div>
	);
};

export default Number;
